import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Action, State, StateContext } from "@ngxs/store";
import { createRequestAction, RequestState } from "ngxs-requests-plugin";

import { environment } from "../../../../environments/environment";
import { AppConfigService } from "../../services/app-config.service";
import { GetLatestDbVersion, GetLatestDbVersionFail, GetDbVersions, GetDbVersionsFail, GetDbVersionsSuccess, GetLatestDbVersionSuccess } from "./dbVersion.actions";
import { catchError, tap, throwError } from "rxjs";


export interface LatestDbVersionStateModel {
  dbVersion: string;
}

@RequestState('getLatestDbVersion')
@Injectable()
export class GetLatestDbVersionRequestState {}

@State<LatestDbVersionStateModel>({
  name: 'dbVersion',
  defaults: {
    dbVersion: ''
  }
})
@Injectable()
export class DbVersionState {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  @Action(GetLatestDbVersion)
  getLatestDbVersion({ dispatch }: StateContext<LatestDbVersionStateModel>) {
    const request = this.http.post(environment.api + 'db/meta/versions/latest', {dbName: this.appConfig.dbName})
      .pipe(
        catchError(error => {
          console.error('API error:', error);
          return throwError(() => error);
      })
      );

    return dispatch(
      createRequestAction({
        request,
        state: GetLatestDbVersionRequestState,
        successAction: GetLatestDbVersionSuccess,
        failAction: GetLatestDbVersionFail      })
    );
  }

  @Action(GetLatestDbVersionSuccess)
  getLatestDbVersionSuccess(
    { patchState }: StateContext<LatestDbVersionStateModel>,
    { payload: response }: GetLatestDbVersionSuccess
  ) {
    patchState({dbVersion: response.content});
  }

  @Action(GetLatestDbVersionFail)
  getLatestDbVersionFail(ctx: StateContext<LatestDbVersionStateModel>, error: any) {
    console.error('GetLatestDbVersionFail triggered', error);
  }
}

export interface DbVersionsStateModel {
  versions: string[];
}

@RequestState('getDbVersions')
@Injectable()
export class GetDbVersionsRequestState {}

@State<DbVersionsStateModel>({
  name: 'dbVersions',
  defaults: {
    versions: []
  }
})
@Injectable()
export class DbVersionsState {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  @Action(GetDbVersions)
  getDbVersions( { dispatch }: StateContext<DbVersionsStateModel> ) {
    const request = this.http.post(environment.api + 'db/meta/versions/all', {dbName: this.appConfig.dbName})

    return dispatch(
      createRequestAction({
        request,
        state: GetDbVersionsRequestState,
        successAction: GetDbVersionsSuccess,
        failAction: GetDbVersionsFail
      })
    );
  }

  @Action(GetDbVersionsSuccess)
  getDbVersionsSuccess(
    { patchState }: StateContext<DbVersionsStateModel>,
    { payload: response }: GetDbVersionsSuccess
  ) {
    patchState({versions: response.content});
  }

  @Action(GetDbVersionsFail)
  getDbVersionsFail(ctx: StateContext<DbVersionsStateModel>, error: any) {
    console.error('GetDbVersionsFail triggered', error);
  }
}
